// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminExecutionEvents = {
  actions: {
    retry: "再試行",
    retryTask: "タスクを再試行",
    processAutoRetries: "期限到来の自動再試行を処理",
  },
  drawer: {
    title: "実行タスク #{id}",
    titleShort: "実行タスク",
    eventTitle: "ランタイムイベント #{id}",
    eventTitleShort: "ランタイムイベント",
    rawEventTitle: "生イベント #{id}",
    rawEventTitleShort: "生イベント",
    requestPayload: "リクエスト内容",
    resultPayload: "実行結果",
  },
  fields: {
    taskId: "関連タスク ID",
    eventAction: "関連アクション",
    eventTrigger: "トリガー",
    workerId: "ワーカー ID",
    requiredCapability: "必要能力",
    dispatchDecision: "配布判定",
    leaseOwner: "lease 所有者",
    leaseExpiresAt: "lease 有効期限",
    retrySource: "再試行元",
    rootTask: "ルートタスク",
    retryDepth: "再試行深度",
    retryCount: "発行済み再試行",
    autoRetryEnabled: "自動再試行",
    autoRetryState: "自動再試行状態",
    autoRetryMax: "自動再試行上限",
    autoRetryDelay: "自動再試行間隔",
    nextRetryAt: "次回再試行",
    latestRetry: "最新再試行",
    startTime: "開始時刻",
    finishTime: "終了時刻",
  },
  columnHelp: {
    event: "この記録は発生したプラットフォームイベントを読みやすい名称で示します。",
    resource: "このイベントの影響対象です。実行タスクや環境インスタンスなどを示します。",
    status: "このイベントに記録された結果状態です。完全な技術ログそのものではありません。",
    eventConclusion: "状態、配布判定、ペイロード概要から業務・ガバナンス視点で要約した結論です。",
    eventCategory:
      "タスク、配布、lease、復旧などの大分類でイベントを整理し、素早く確認できるようにします。",
  },
  messages: {
    taskDetailLoadFailed: "タスク詳細の取得に失敗しました",
    taskRetryStarted: "再試行タスク #{id} を開始しました",
    taskRetryFailed: "タスクの再試行に失敗しました",
    autoRetryProcessed:
      "{scanned} 件を走査し、{triggered} 件を発行し、{dispatchFailed} 件が発行失敗しました",
    autoRetryProcessFailed: "自動再試行処理に失敗しました",
  },
  values: {
    retryable: "再試行可",
    retried: "再試行済み",
    succeeded: "成功済み",
    exhausted: "再試行不可",
    retryScheduled: "自動再試行待ち",
    scheduled: "自動再試行待ち",
    processing: "処理中",
    dispatchRetried: "再試行を発行済み",
    dispatchFailed: "発行失敗",
    deadLettered: "デッドレター到達",
    manualInterventionRequired: "手動介入が必要",
    autoRetryExhausted: "自動再試行上限到達",
    pending: "待機中",
    running: "実行中",
    success: "成功",
    failed: "失敗",
    cancelled: "キャンセル済み",
    eventTaskPending: "タスクが待機列に入りました",
    eventTaskClaimed: "タスクを取得しました",
    eventTaskClaimReleased: "タスク取得を解放しました",
    eventTaskRunning: "タスク実行開始",
    eventTaskSucceeded: "タスク実行成功",
    eventTaskFailed: "タスク実行失敗",
    eventTaskCancelled: "タスクがキャンセルされました",
    eventTaskCancellationRequested: "キャンセル要求を記録しました",
    eventTaskLeaseRenewed: "タスク lease を更新しました",
    eventTaskClaimConflicted: "タスク取得で競合が発生しました",
    eventTaskDispatchCapabilityMismatch: "配布能力が一致しません",
    eventTaskDispatchRateLimited: "配布がレート制限されました",
    eventTaskAutoRetryDispatchFailed: "自動再試行の配布に失敗しました",
    eventTaskAutoRetryDeadLettered: "自動再試行が死信化されました",
    eventTaskAutoRetryManualInterventionRequired: "自動再試行に手動対応が必要です",
    eventTaskStaleRunningDetected: "実行中タスクが異常復旧に入りました",
    eventStatusRecorded: "記録済み",
    eventCategoryTask: "タスク",
    eventCategoryDispatch: "配布",
    eventCategoryLease: "lease",
    eventCategoryRecovery: "復旧",
    eventCategoryOther: "その他",
    resourceExecutionTask: "実行タスク",
    resourceEnvironmentInstance: "環境インスタンス",
    resourceExecutionTaskWithId: "実行タスク #{id}",
    resourceEnvironmentInstanceWithId: "環境インスタンス #{id}",
    eventConclusionSuccess: "成功結果として完了・記録されました",
    eventConclusionFailed: "実行に失敗しており、調査が必要です",
    eventConclusionFailedWithReason: "実行失敗：{reason}",
    eventConclusionRetryState: "現在の再試行状態：{value}",
  },
} as const;
